import { Component } from "react";
import Toolbar from "../components/toolbar";
import { MdAddBox } from "react-icons/md";
import { addDoc, collection, deleteDoc, getDocs, orderBy, query, updateDoc } from "firebase/firestore/lite";
import { dbPublic } from "../../App";
import { FaEdit, FaTrash } from "react-icons/fa";
import { CgCloseO } from "react-icons/cg";
import { TiCancel } from "react-icons/ti";
import { ImCheckmark } from "react-icons/im";


class Sires extends Component<any,any> {

    constructor(props:any)
    {
        super(props);
        this.state = {
            updating: false,
            UpdateImageInfo: false,
            sires: [],
            sire: {},
            sireDoc: {},
            sirePics: [],
            sireCKCPics: [],
            sireImage: {},
            deletedPics: [],
            deletedCKCPics: [],
        }
    }

    async componentDidMount() {
        var tCol = collection(dbPublic,'sires');
        getDocs(query(tCol,orderBy("order",'asc'))).then(tSnap => {
            this.setState({sires: tSnap.docs});
        });
    }

    async downloadPics(files:FileList)
    {
        console.log(this.state.sirePics.length);
        for(var i=0; i<files.length; i++)
        {

            var x = new FileReader();
            x.onload = (a) => {
                
                var pic = {
                    description: '',
                    image: a.target?.result,
                    order: this.state.sirePics.length + 1,
                    id: '', ref: ''
                }
                this.state.sirePics.push(pic)
                this.setState({sirePics: this.state.sirePics});
            }
            x.readAsDataURL(files[i]);
        }
       
    }

    async downloadCKCPics(files:FileList)
    {
        console.log(this.state.sireCKCPics.length);
        if(this.state.sireCKCPics.length > 0)
        {
            var x = new FileReader();
            x.onload = (a) => {
                var pic = {
                    description: '',
                    image: a.target?.result,
                    order: 1,
                    id: '', ref: ''
                }
                this.state.sireCKCPics[0] = pic;
                this.setState({sireCKCPics: this.state.sireCKCPics});
            }
            x.readAsDataURL(files[0]);
        } else {
            var x = new FileReader();
            x.onload = (a) => {
                var pic = {
                    description: '',
                    image: a.target?.result,
                    order: 1,
                    id: '', ref: ''
                }
                this.state.sireCKCPics.push(pic)
                this.setState({sireCKCPics: this.state.sireCKCPics});
            }
            x.readAsDataURL(files[0]);
        }
    }

    render() {

        return(
        <div style={{height: '100%', fontFamily: 'avenir'}}>
            <Toolbar />
            <section style={{marginLeft: '210px',height: '100%',display: 'flex',flexDirection:'column', justifyContent: 'flex-start', alignItems: 'flex-start'}}>
            <div style={{width: '100%', fontFamily: 'avenirb', fontSize: '30pt'}}>
                SIRES
            </div>
            <div>
                <div style={{fontFamily: 'avenirb'}}></div>
                Add or edit Sires for the website.<br/><br/>
                <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', cursor: 'pointer'}} onClick={()=>{
                    this.setState({updating: true});
                }}><MdAddBox style={{color: 'rgba(0,200,0,1)'}} size={30} /> ADD SIRE</div>
                <br/>
            </div>
            <div style={{display: 'flex',borderBottom: '1px dotted #000'}}>
                <div style={{width: '200px'}}><b>Name</b></div>
                <div style={{width: '200px'}}><b>DOB</b></div>
                {/* <div style={{width: '150px'}}><b>Display Order</b></div> */}
                <div style={{width: '150px'}}><b>OFA/Registration #</b></div>
                <div style={{width: '400px'}}><b>OFA Health</b></div>
                <div style={{width: '300px'}}><b>Notes</b></div>
                <div style={{width: '200px'}}><b>Sire</b></div>
                <div style={{width: '200px'}}><b>Dame</b></div>
                <div style={{width: '100px'}}></div>
            </div>
            {this.state.sires.map((sire:any,i:number)=>{
                var s = sire.data();
                return(
                    <div key={i} style={{fontSize: '10pt',display: 'flex',marginTop: '10px',paddingBottom: '10px',borderBottom: '1px solid rgba(0,0,0,.2)'}}>
                        <div style={{width: '200px'}}><b>{s.name}</b></div>
                        <div style={{width: '200px'}}><b>{s.dob}</b></div>
                        {/* <div style={{width: '150px'}}><b>{s.order}</b></div> */}
                        <div style={{width: '150px'}}><b>{s.OFA}</b></div>
                        <div style={{width: '400px'}}><b>
                        {s.Heart != '' ? 
                        <div style={{display: 'flex'}}>
                            <div style={{flex:1,fontFamily: 'avenirb'}}>
                                Basic Cardiac
                            </div>
                            <div style={{flex: 1}}>
                                ✅ {s.Heart}
                            </div>
                        </div>
                        : null}
                        {s.Hyperuricosuria != '' ?
                        <div style={{display: 'flex',}}>
                            <div style={{flex:1, fontFamily: 'avenirb'}}>
                                Hyperusricosuria
                            </div>
                            <div style={{flex: 1}}>
                                ✅ {s.Hyperuricosuria}
                            </div>
                        </div>
                        : null}
                        {s.Thyroid != '' ? 
                        <div style={{display: 'flex'}}>
                            <div style={{flex:1,fontFamily: 'avenirb'}}>
                                Thyroid
                            </div>
                            <div style={{flex: 1}}>
                                ✅ {s.Thyroid}
                            </div>
                        </div>
                        : null }
                        {s.Trachea != '' ? 
                        <div style={{display: 'flex'}}>
                            <div style={{flex:1,fontFamily: 'avenirb'}}>
                                Tracheal Hypoplasia
                            </div>
                            <div style={{flex: 1}}>
                                ✅ {s.Trachea}
                            </div>
                        </div>
                        : null }
                        {s.Hips != '' ? 
                        <div style={{display: 'flex'}}>
                            <div style={{flex:1,fontFamily: 'avenirb'}}>
                                Hips
                            </div>
                            <div style={{flex: 1}}>
                                ✅ {s.Hips}
                            </div>
                        </div>
                        : null }
                        {s.Elbows != '' ? 
                        <div style={{display: 'flex'}}>
                            <div style={{flex:1,fontFamily: 'avenirb'}}>
                                Elbows
                            </div>
                            <div style={{flex: 1}}>
                                ✅ {s.Elbows}
                            </div>
                        </div>
                        : null }
                        {s.Eyes != '' ? 
                        <div style={{display: 'flex'}}>
                            <div style={{flex:1,fontFamily: 'avenirb'}}>
                                Eyes
                            </div>
                            <div style={{flex: 1}}>
                                ✅ {s.Eyes}
                            </div>
                        </div>
                        : null }
                        {s.BOAS != '' ? 
                        <div style={{display: 'flex'}}>
                            <div style={{flex:1,fontFamily: 'avenirb'}}>
                            Brachycephalic Obstructive Airway Syndrome (BOAS)
                            </div>
                            <div style={{flex: 1}}>
                                ✅ {s.BOAS}
                            </div>
                        </div>
                        : null }

                        </b></div>
                        <div style={{width: '300px'}}><b>{s.Notes}</b></div>
                        <div style={{width: '200px'}}><b>{s.Sire}</b></div>
                        <div style={{width: '200px'}}><b>{s.Dame}</b></div>
                        <div style={{width: '100px'}}>
                            
                            <FaEdit size={25} style={{marginRight: '30px', cursor: 'pointer'}} onClick={()=>{
                                var tCol = collection(dbPublic,'sires/' + sire.id + '/pictures');
                                getDocs(query(tCol,orderBy("order", 'asc'))).then((docs)=>{
                                    var pics:any = [];
                                    docs.docs.map((pic:any)=>{
                                        var p = pic.data();
                                        pics.push({image: p.image, id: pic.id, ref: pic.ref, description: p.description, order: p.order});
                                    })
                                    this.setState({sirePics: pics});
                                })
                                tCol = collection(dbPublic,'sires/' + sire.id + '/CKCpictures');
                                getDocs(query(tCol,orderBy("order", 'asc'))).then((docs)=>{
                                    var pics:any = [];
                                    docs.docs.map((pic:any)=>{
                                        var p = pic.data();
                                        pics.push({image: p.image, id: pic.id, ref: pic.ref, description: p.description, order: p.order});
                                    })
                                    this.setState({sireCKCPics: pics});
                                })
                                this.setState({updating: true, sire: s, sireDoc: sire});
                            }}/>

                            <FaTrash size={15} style={{marginRight: '30px', cursor: 'pointer', color: 'rgba(200,0,0,1)'}} onClick={async ()=>{
                                var tCol = collection(dbPublic,'sires');
                                await deleteDoc(sire.ref);
                                var tSnap = await getDocs(query(tCol,orderBy("order",'asc')));
                                this.setState({sires: tSnap.docs});
                            }}/>
                        </div>
                    </div>
                )
            })}
            {this.state.updating ?
            <div className="overlay" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <div style={{width: 700, maxHeight: 'none', overflow: 'hidden'}} className="window" >
                    <div className="closeWindow" onClick={()=>{
                        this.setState({updating: false, testimonial: {}, testimonialDoc: {}});
                    }}>
                        <CgCloseO />
                    </div>
                    <div className="windowTitle">
                        ADD/EDIT SIRE
                    </div>
                    <div className="formStyle" style={{position: 'relative',overflowX: 'hidden', overflowY: 'auto', scrollbarWidth: 'thin', height: '80%', top: 0,}}>
                        
                        <div className="label">
                            Name
                        </div>
                        <div className="input" style={{}}>
                            <input type="text" required name="name" style={{width: '90%'}} defaultValue={this.state.sire.name}/>
                        </div>
                        <div style={{display: 'flex'}}>
                            <div style={{flex: .5}}>
                                <div className="label">
                                    DOB
                                </div>
                                <div className="input">
                                    <input type="text" required name="dob" style={{width: '80%'}} placeholder="ie. February 02, 2025" defaultValue={this.state.sire.dob} />
                                </div>
                            </div>
                            
                            <div style={{flex: .5}}>
                                <div className="label">
                                    OFA/Registration #
                                </div>
                                <div className="input">
                                    <input type="text" required name="ofa" style={{width: '80%'}} defaultValue={this.state.sire.OFA} />
                                </div>
                            </div>
                        </div>
                        <div style={{display: 'flex'}}>
                            <div style={{flex: .5}}>
                                <div className="label">
                                    Sire
                                </div>
                                <div className="input">
                                    <input type="text" required name="sire" style={{width: '80%'}} defaultValue={this.state.sire.Sire}/>
                                </div>
                            </div>
                            
                            <div style={{flex: .5}}>
                                <div className="label">
                                    Dame
                                </div>
                                <div className="input">
                                    <input type="text" required name="dame" style={{width: '80%'}} defaultValue={this.state.sire.Dame}/>
                                </div>
                            </div>
                        </div>

                        <div className="label">
                            Notes
                        </div>
                        <div className="input" style={{}}>
                            <textarea required name="notes" style={{width: '90%'}} defaultValue={this.state.sire.Notes}/>
                        </div>

                        <div>
                            OFA Health Checks
                        </div>
                        <div style={{display: 'flex', flexWrap: 'wrap'}}>
                            

                            <div style={{flex: .5}}>
                                <div className="label">
                                    Cardiac/Heart
                                </div>
                                <div className="input">
                                    <input type="text" required name="cardiac" style={{width: '80%'}} defaultValue={this.state.sire.Heart} />
                                </div>
                            </div>
                            
                            <div style={{flex: .5}}>
                                <div className="label">
                                    Hyperuricosuria
                                </div>
                                <div className="input">
                                    <input type="text" required name="hyperusricosuria" style={{width: '80%'}} defaultValue={this.state.sire.Hyperuricosuria} />
                                </div>
                            </div>

                            <div style={{flex: .5}}>
                                <div className="label">
                                    Hips
                                </div>
                                <div className="input">
                                    <input type="text" required name="hips" style={{width: '80%'}} defaultValue={this.state.sire.Hips}/>
                                </div>
                            </div>
                        </div>

                        <div style={{display: 'flex', flexWrap: 'wrap'}}>
                            <div style={{flex: .5}}>
                                <div className="label">
                                    Elbows
                                </div>
                                <div className="input">
                                    <input type="text" required name="elbows" style={{width: '80%'}} defaultValue={this.state.sire.Elbows}/>
                                </div>
                            </div>
                            
                            <div style={{flex: .5}}>
                                <div className="label">
                                    Eyes
                                </div>
                                <div className="input">
                                    <input type="text" required name="eyes" style={{width: '80%'}} defaultValue={this.state.sire.Eyes}/>
                                </div>
                            </div>

                            <div style={{flex: .5}}>
                                <div className="label">
                                    Thyroid
                                </div>
                                <div className="input">
                                    <input type="text" required name="thyroid" style={{width: '80%'}} defaultValue={this.state.sire.Thyroid}/>
                                </div>
                            </div>
                        </div>

                        <div style={{display: 'flex', flexWrap: 'wrap'}}>
                            <div style={{flex: .33}}>
                                <div className="label">
                                    Tracheal Hypoplasia
                                </div>
                                <div className="input">
                                    <input type="text" required name="trachea" style={{width: '80%'}} defaultValue={this.state.sire.Trachea}/>
                                </div>
                            </div>

                            <div style={{flex: .5}}>
                                <div className="label">
                                    BOAS
                                </div>
                                <div className="input">
                                    <input type="text" required name="BOAS" style={{width: '80%'}} defaultValue={this.state.sire.BOAS} />
                                </div>
                            </div>
                        </div>
                        <div>
                            CKC Pedigree Image
                        </div>
                        <div className="PictureBoxDD" style={{position: 'relative',width: '95%', border: '3px dashed rgba(0,0,0,.3)', backgroundColor: 'rgba(200,0,0,.3)'}} onDrop={(e)=>{
                            e.preventDefault();
                            
                            this.downloadCKCPics(e.dataTransfer.files);
                        }} onDragOver={(e)=>{e.preventDefault();}} onDragEnter={(e)=>{e.preventDefault();}}>
                            <div style={{width: '100%', height: '100%', padding: 30, display: 'flex'}}>Drag/Drop CKC Pedigree Certificate here or&nbsp;<br/><div style={{position: 'relative', textDecoration: 'underline', cursor: 'pointer'}}>click here <input type="file" multiple name="file" id="file" style={{position: 'absolute', cursor: 'pointer', left: 0, top: 0, opacity: 0,  }} onChange={(e)=>{
                                
                                this.downloadCKCPics(e.target.files!); 
                            }}/></div>&nbsp;to select images.
                            
                            </div>
                        </div>
                        <hr/>
                        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(100px,1fr)', gap: 5, padding: 5,}}>
                        {this.state.sireCKCPics.sort((a:any,b:any)=> a.order - b.order).map((pic:any,idx:number)=>{
                            var p = pic;
                            
                            return(
                                <div key={idx} style={{position: 'relative'}}>
                                    <img src={p.image} style={{width: '100%', height: 'auto', borderRadius: '10px', cursor: 'pointer'}} onClick={()=>{
                                        // this.setState({UpdatingImageInfo: true, sireImage: {idx: idx, pic: p}});
                                    }}/><br/>
                                    <span style={{fontSize: '8pt'}}>{p.description}</span>
                            
                                    <div style={{position: 'absolute', top: -5, right: -5, height: 20, width: 20, backgroundColor: 'black', color: 'white', borderRadius: 10, textAlign: 'center', fontSize: '12pt', fontFamily: 'avenirb', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer'}} onClick={()=>{
                                        this.state.deletedCKCPics.push(this.state.sireCKCPics[idx]);
                                        this.state.sireCKCPics.splice(idx,1);
                                        this.setState({sireCKCPics: this.state.sireCKCPics});
                                    }}><CgCloseO /></div>
                                </div>
                            )
                        })}
                        </div>
                        
                        <hr/>
                        <div>
                            Pictures
                        </div>
                        <div className="PictureBoxDD" style={{position: 'relative',width: '95%', border: '3px dashed rgba(0,0,0,.3)', backgroundColor: 'rgba(200,0,0,.3)'}} onDrop={(e)=>{
                            e.preventDefault();
                            
                            this.downloadPics(e.dataTransfer.files);
                        }} onDragOver={(e)=>{e.preventDefault();}} onDragEnter={(e)=>{e.preventDefault();}}>
                            <div style={{width: '100%', height: '100%', padding: 30, display: 'flex'}}>Drag and drop pictures here or&nbsp;<br/><div style={{position: 'relative', textDecoration: 'underline', cursor: 'pointer'}}>click here <input type="file" multiple name="file" id="file" style={{position: 'absolute', cursor: 'pointer', left: 0, top: 0, opacity: 0,  }} onChange={(e)=>{
                                
                                this.downloadPics(e.target.files!); 
                            }}/></div>&nbsp;to select images.
                            
                            </div>
                        </div>
                        <hr/>
                        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(100px,1fr)', gap: 5, padding: 5,}}>
                        {this.state.sirePics.sort((a:any,b:any)=> a.order - b.order).map((pic:any,idx:number)=>{
                            var p = pic;
                            
                            return(
                                <div key={idx} style={{position: 'relative'}}>
                                    <img src={p.image} style={{width: '100%', height: 'auto', borderRadius: '10px', cursor: 'pointer'}} onClick={()=>{
                                        this.setState({UpdatingImageInfo: true, sireImage: {idx: idx, pic: p}});
                                    }}/><br/>
                                    <span style={{fontSize: '8pt'}}>{p.description}</span>
                            
                                    <div style={{position: 'absolute', top: -5, right: -5, height: 20, width: 20, backgroundColor: 'black', color: 'white', borderRadius: 10, textAlign: 'center', fontSize: '12pt', fontFamily: 'avenirb', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer'}} onClick={()=>{
                                        this.state.deletedPics.push(this.state.sirePics[idx]);
                                        this.state.sirePics.splice(idx,1);
                                        this.setState({sirePics: this.state.sirePics});
                                    }}><CgCloseO /></div>
                                </div>
                            )
                        })}
                        </div>
                    </div>



                    <div className="buttons">
                        <button className="cancelButton" onClick={()=>{
                            this.setState({updating: false, sire: {}, sireDoc: {}, deletedPics: []});
                        }}><TiCancel /> CANCEL</button>
                        <button className="acceptButton" onClick={async ()=>{
                                // delete the pictures first
                                this.setState({isProcessing: true});
                                this.state.deletedPics.map(async (p:any,i0:number)=>{
                                    var tCol = collection(dbPublic,'sires/' + this.state.sireDoc.id + '/pictures');
                                    await deleteDoc(p.ref);
                                });

                                // delete CKC pictures
                                this.state.deletedCKCPics.map(async (p:any,i0:number)=>{
                                    var tCol = collection(dbPublic,'sires/' + this.state.sireDoc.id + '/CKCpictures');
                                    await deleteDoc(p.ref);
                                });
                                
                                // update information
                                var tCol = collection(dbPublic,'sires');
                                var docID = '';
                                if (this.state.sireDoc.id && this.state.sireDoc.id != ''){ 
                                    docID = this.state.sireDoc.id
                                    await updateDoc(this.state.sireDoc.ref,{
                                        name: (document.getElementsByName("name")[0] as HTMLInputElement).value,
                                        dob: (document.getElementsByName("dob")[0] as HTMLInputElement).value,
                                        OFA: (document.getElementsByName("ofa")[0] as HTMLInputElement).value,
                                        Sire: (document.getElementsByName("sire")[0] as HTMLInputElement).value,
                                        Dame: (document.getElementsByName("dame")[0] as HTMLInputElement).value,
                                        Notes: (document.getElementsByName("notes")[0] as HTMLInputElement).value,
                                        Heart: (document.getElementsByName("cardiac")[0] as HTMLInputElement).value,
                                        Hyperuricosuria: (document.getElementsByName("hyperusricosuria")[0] as HTMLInputElement).value,
                                        Hips: (document.getElementsByName("hips")[0] as HTMLInputElement).value,
                                        Elbows: (document.getElementsByName("elbows")[0] as HTMLInputElement).value,
                                        Eyes: (document.getElementsByName("eyes")[0] as HTMLInputElement).value,
                                        Thyroid: (document.getElementsByName("thyroid")[0] as HTMLInputElement).value,
                                        Trachea: (document.getElementsByName("trachea")[0] as HTMLInputElement).value,
                                        BOAS: (document.getElementsByName("BOAS")[0] as HTMLInputElement).value,
                                    });
                                } else {
                                    var doc = await addDoc(tCol,{
                                        name: (document.getElementsByName("name")[0] as HTMLInputElement).value,
                                        dob: (document.getElementsByName("dob")[0] as HTMLInputElement).value,
                                        OFA: (document.getElementsByName("ofa")[0] as HTMLInputElement).value,
                                        Sire: (document.getElementsByName("sire")[0] as HTMLInputElement).value,
                                        Dame: (document.getElementsByName("dame")[0] as HTMLInputElement).value,
                                        Notes: (document.getElementsByName("notes")[0] as HTMLInputElement).value,
                                        Heart: (document.getElementsByName("cardiac")[0] as HTMLInputElement).value,
                                        Hyperuricosuria: (document.getElementsByName("hyperusricosuria")[0] as HTMLInputElement).value,
                                        Hips: (document.getElementsByName("hips")[0] as HTMLInputElement).value,
                                        Elbows: (document.getElementsByName("elbows")[0] as HTMLInputElement).value,
                                        Eyes: (document.getElementsByName("eyes")[0] as HTMLInputElement).value,
                                        Thyroid: (document.getElementsByName("thyroid")[0] as HTMLInputElement).value,
                                        Trachea: (document.getElementsByName("trachea")[0] as HTMLInputElement).value,
                                        BOAS: (document.getElementsByName("BOAS")[0] as HTMLInputElement).value,
                                        order: 999,
                                    });
                                    docID = doc.id;
                                    console.log("New Sire ID", docID);
                                    this.setState({sireDoc: { id: doc.id, ref: doc}});
                                    
                                }
                                // Update/Add picture information
                                this.state.sirePics.map(async (p:any,i0:number)=>{
                                    var tCol = collection(dbPublic,'sires/' + docID + '/pictures');
                                    if (p.ref != null && p.ref != '') {
                                        //existing picture.. just update information
                                        console.log("updating picture");
                                        await updateDoc(p.ref,{order: p.order, description: p.description });
                                    } else {
                                        //new picture.. lets add it.
                                        console.log("Adding picture", p);
                                        await addDoc(tCol,{order: p.order, description: p.description, image: p.image});
                                    }
                                });

                                // Update/Add CKC Predigree picture information
                                this.state.sireCKCPics.map(async (p:any,i0:number)=>{
                                    var tCol = collection(dbPublic,'sires/' + docID + '/CKCpictures');
                                    if (p.ref != null && p.ref != '') {
                                        //existing picture.. just update information
                                        console.log("updating CKC picture");
                                        await updateDoc(p.ref,{order: p.order, description: p.description });
                                    } else {
                                        //new picture.. lets add it.
                                        console.log("Adding CKC picture", p);
                                        await addDoc(tCol,{order: p.order, description: p.description, image: p.image});
                                    }
                                });

                                // all done.. lets clear our settings and close out.
                                var tCol = collection(dbPublic,'sires');
                                var tSnap = await getDocs(query(tCol,orderBy("order",'asc')));
                                this.setState({
                                    sires: tSnap.docs,
                                    sire: {},
                                    sireDoc: {},
                                    sirePics: [],
                                    sireImage: {},
                                    deletedPics: [], updating: false,isProcessing: false});

                        }} ><ImCheckmark /> CONFIRM</button>
                    </div>
                </div>
            </div>
            : null }

            {this.state.UpdatingImageInfo ?
                <div className="overlay">
                    <div className="window" style={{maxHeight: 'none', height: 'auto'}}>
                        <div className="closeWindow" onClick={()=>{
                            this.setState({UpdatingImageInfo: false, sirePic: {}});
                        }}>
                            <CgCloseO />
                        </div>
                        <div className="windowTitle">
                            Edit Picture
                        </div>
                        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', maxHeight: 'none'}}>
                            <img src={this.state.sireImage.pic.image} style={{width: '100%', height: 'auto', borderRadius: '10px', cursor: 'pointer'}} />
                        </div>
                        <div className="formStyle" style={{marginTop: 0}}>
                            <div className="label">
                                Description
                            </div>
                            <div className="input" style={{width: '90%'}}>
                                <input type="text" style={{width: '100%'}} name="imageDesc" defaultValue={this.state.sireImage.pic.description} />
                            </div>
                            <div className="label">
                                Display Order/Priority
                            </div>
                            <div className="input" style={{width: '50%'}}>
                                <input type="text" style={{width: '100%'}} name="imageOrder" defaultValue={this.state.sireImage.pic.order} />
                            </div>
                            
                        </div>
                        <div style={{height: '100px'}}> </div>
                        <div className="buttons">
                            <button className="cancelButton" onClick={()=>{
                                this.setState({UpdatingImageInfo: false, sirePic: {}});
                            }}><TiCancel /> CANCEL</button>
                            <button className="acceptButton" onClick={async ()=>{
                                    var desc = (document.getElementsByName("imageDesc")[0] as HTMLInputElement).value;
                                    var order = (document.getElementsByName("imageOrder")[0] as HTMLInputElement).value;
                                    this.state.sireImage.pic.order = parseInt(order);
                                    this.state.sireImage.pic.description = desc;
                                    this.state.sirePics[this.state.sireImage.idx] = this.state.sireImage.pic;
                                    this.setState({sirePics: this.state.sirePics, UpdatingImageInfo: false});

                            }} ><ImCheckmark /> CONFIRM</button>
                        </div>

                    </div>
                </div>
            : null}
            </section>

            {this.state.isProcessing ?
            <div style={{position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.8)', justifyContent: 'center', alignItems: 'center', display: 'flex',zIndex: 99999}}>
                <div style={{width: '80%', textAlign: 'center', color: '#fff'}}>
                    Please wait...
                    <progress style={{width: '100%', height: '10px'}}></progress>
                </div>
            </div> : null}
        </div>
        );
    }
}

export default Sires;